import React from "react";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPMarketingParagraph } from "../../Simple/FPMarketingParagraph/FPMarketingParagraph";
import { THexColor, TPixelSize } from "../../../../models/StringLiterals";

type TMarketingParagraphColumnProps = {
    color?: THexColor;
    align?: "left" | "center" | "right";
    size?: number;
    spacing?: TPixelSize;
    paragraphs: Array<JSX.Element>;
};

export const FPMarketingParagraphColumn = (props: React.PropsWithChildren<TMarketingParagraphColumnProps>): JSX.Element => {

    return (
        <SpacingColumn spacing={props.spacing || "25px"}>
            {props.paragraphs.map((text, key) => (
                <FPMarketingParagraph
                    key={key}
                    align={props.align}
                    color={props.color}
                    size={props.size}
                >
                    {text}
                </FPMarketingParagraph>
            ))}
        </SpacingColumn>
    );
};
